import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const FooterContainer = styled.footer`
  background-color: #1b5e20;
  color: white;
  padding: 40px 0 20px;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FooterSection = styled.div`
  flex: 1;
  min-width: 250px;
`;

const FooterTitle = styled.h3`
  margin-bottom: 20px;
  font-size: 1.3rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: 0;
    width: 50px;
    height: 2px;
    background-color: #8bc34a;
  }
`;

const FooterList = styled.ul`
  list-style: none;
  padding: 0;
`;

const FooterListItem = styled.li`
  margin-bottom: 10px;
`;

const FooterLink = styled.a`
  color: #e0e0e0;
  transition: color 0.3s ease;
  
  &:hover {
    color: #8bc34a;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <FooterTitle>{t('about')}</FooterTitle>
            <p>{t('about_desc').substring(0, 150)}...</p>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>{t('services')}</FooterTitle>
            <FooterList>
              <FooterListItem>
                <FooterLink href="#">{t('service1')}</FooterLink>
              </FooterListItem>
              <FooterListItem>
                <FooterLink href="#">{t('service2')}</FooterLink>
              </FooterListItem>
              <FooterListItem>
                <FooterLink href="#">{t('service3')}</FooterLink>
              </FooterListItem>
              <FooterListItem>
                <FooterLink href="#">{t('service4')}</FooterLink>
              </FooterListItem>
            </FooterList>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>{t('contact_title')}</FooterTitle>
            <FooterList>
              <FooterListItem>
                <strong>{t('address')}:</strong> {t('address')}
              </FooterListItem>
              <FooterListItem>
                <strong>{t('phone')}:</strong> {t('phone')}
              </FooterListItem>
              <FooterListItem>
                <strong>Email:</strong> {t('email')}
              </FooterListItem>
            </FooterList>
          </FooterSection>
        </FooterContent>
        
        <Copyright>
          {t('footer')}
        </Copyright>
      </div>
    </FooterContainer>
  );
};

export default Footer;
